import React, { useState } from "react";
import { imageUploader } from "../../../utilities/fileHandlers";

function ImageField({ title, name, id, accepts, minSize, style, handler }) {
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState("")
    function handleChange(e) {
        setFileName(e.target.files[0].name)
        setFile(URL.createObjectURL(e.target.files[0]));
        imageUploader(e.target.files[0], handler)
    }


    return (
        <div className="row mt-2">
            <div className="col-6">
                <div className="form-group">
                    <label>
                        {title} <strong className="text-danger">*</strong>
                    </label>
                    <div className="custom-file">
                        <input
                            name={name}
                            type="file"
                            id={id}
                            className="custom-file-input"
                            accept={accepts}
                            onChange={handleChange}
                        />
                        <label htmlFor={id} className="custom-file-label">
                            {fileName}
                        </label>
                    </div>
                </div>
            </div>
            <div className="col-6">
                <div>
                    {file !== null ?
                        <img src={file} className="img-thumbnail" alt={`${id}`} style={style} />
                        :
                        <div className="img-frame" style={style} >{title}</div>
                    }
                </div>
                <div>
                    <small className="text-danger">{title} must be atleast {minSize} pixels<sup>*</sup> </small>
                </div>
            </div>
        </div>

    );
}

export default ImageField;
